import { Course } from './../../../../interfaces/course';
import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {

  data: Course[];

  currentPage = 1;
  totalItemsPerPage = 20;

  constructor(
    private db: DataService,
  ) { }

  ngOnInit() {
    this.db.getCourses({
      orderBy: 'date'
    }).subscribe((data) => {
      this.data = data;
    });
  }
}
